var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _vm.chart.type && _vm.chart.type === "gauge"
        ? _c(
            "el-col",
            [
              _c(
                "el-form",
                {
                  ref: "thresholdForm",
                  attrs: {
                    model: _vm.thresholdForm,
                    "label-width": "80px",
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.threshold_range") + "(%)" },
                    },
                    [
                      _c("span", [_vm._v("0,")]),
                      _c("el-input", {
                        staticStyle: { width: "100px", margin: "0 10px" },
                        attrs: {
                          placeholder: _vm.$t("chart.threshold_range"),
                          size: "mini",
                          clearable: "",
                        },
                        on: { change: _vm.gaugeThresholdChange },
                        model: {
                          value: _vm.thresholdForm.gaugeThreshold,
                          callback: function ($$v) {
                            _vm.$set(_vm.thresholdForm, "gaugeThreshold", $$v)
                          },
                          expression: "thresholdForm.gaugeThreshold",
                        },
                      }),
                      _c("span", [_vm._v(",100")]),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: { effect: "dark", placement: "bottom" },
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                "\n            阈值设置，决定仪表盘区间颜色，为空则不开启阈值，范围(0-100)，逐级递增\n            "
                              ),
                              _c("br"),
                              _vm._v(
                                "\n            例如：输入 30,70；表示：分为3段，分别为[0,30],(30,70],(70,100]\n          "
                              ),
                            ]
                          ),
                          _c("i", {
                            staticClass: "el-icon-info",
                            staticStyle: {
                              cursor: "pointer",
                              "margin-left": "10px",
                              "font-size": "12px",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.chart.type && _vm.chart.type === "label"
        ? _c(
            "el-col",
            [
              _c(
                "el-col",
                [
                  _c("el-button", {
                    staticStyle: { width: "24px", "margin-left": "4px" },
                    attrs: {
                      title: _vm.$t("chart.edit"),
                      icon: "el-icon-edit",
                      type: "text",
                      size: "small",
                    },
                    on: { click: _vm.editTextLabelThreshold },
                  }),
                  _c(
                    "el-col",
                    { staticStyle: { padding: "0 18px" } },
                    _vm._l(
                      _vm.thresholdForm.textLabelThreshold,
                      function (item, index) {
                        return _c(
                          "el-row",
                          { key: index, staticClass: "line-style" },
                          [
                            _c("el-col", { attrs: { span: 6 } }, [
                              item.term === "eq"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_eq"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.filter_eq")))]
                                  )
                                : item.term === "not_eq"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_not_eq"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.filter_not_eq"))
                                      ),
                                    ]
                                  )
                                : item.term === "like"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_like"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.filter_like"))
                                      ),
                                    ]
                                  )
                                : item.term === "not like"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_not_like"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.filter_not_like"))
                                      ),
                                    ]
                                  )
                                : item.term === "null"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_null"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.filter_null"))
                                      ),
                                    ]
                                  )
                                : item.term === "not_null"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_not_null"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.filter_not_null"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _c("el-col", { attrs: { span: 12 } }, [
                              !item.term.includes("null")
                                ? _c("span", { attrs: { title: item.value } }, [
                                    _vm._v(_vm._s(item.value)),
                                  ])
                                : _c("span", [_vm._v(" ")]),
                            ]),
                            _c("el-col", { attrs: { span: 6 } }, [
                              _c("span", {
                                style: {
                                  width: "14px",
                                  height: "14px",
                                  backgroundColor: item.color,
                                  border: "solid 1px #e1e4e8",
                                },
                              }),
                            ]),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.chart.type && _vm.chart.type === "text"
        ? _c(
            "el-col",
            [
              _c(
                "el-col",
                [
                  _c("el-button", {
                    staticStyle: { width: "24px", "margin-left": "4px" },
                    attrs: {
                      title: _vm.$t("chart.edit"),
                      icon: "el-icon-edit",
                      type: "text",
                      size: "small",
                    },
                    on: { click: _vm.editLabelThreshold },
                  }),
                  _c(
                    "el-col",
                    { staticStyle: { padding: "0 18px" } },
                    _vm._l(
                      _vm.thresholdForm.labelThreshold,
                      function (item, index) {
                        return _c(
                          "el-row",
                          { key: index, staticClass: "line-style" },
                          [
                            _c("el-col", { attrs: { span: 6 } }, [
                              item.term === "eq"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_eq"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.filter_eq")))]
                                  )
                                : item.term === "not_eq"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_not_eq"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.filter_not_eq"))
                                      ),
                                    ]
                                  )
                                : item.term === "lt"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_lt"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.filter_lt")))]
                                  )
                                : item.term === "gt"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_gt"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.filter_gt")))]
                                  )
                                : item.term === "le"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_le"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.filter_le")))]
                                  )
                                : item.term === "ge"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_ge"),
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("chart.filter_ge")))]
                                  )
                                : item.term === "between"
                                ? _c(
                                    "span",
                                    {
                                      attrs: {
                                        title: _vm.$t("chart.filter_between"),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("chart.filter_between"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _c("el-col", { attrs: { span: 12 } }, [
                              item.term !== "between"
                                ? _c("span", { attrs: { title: item.value } }, [
                                    _vm._v(_vm._s(item.value)),
                                  ])
                                : _vm._e(),
                              item.term === "between"
                                ? _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.min) +
                                        " ≤" +
                                        _vm._s(
                                          _vm.$t("chart.drag_block_label_value")
                                        ) +
                                        "≤ " +
                                        _vm._s(item.max) +
                                        "\n            "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c("el-col", { attrs: { span: 6 } }, [
                              _c("span", {
                                style: {
                                  width: "14px",
                                  height: "14px",
                                  backgroundColor: item.color,
                                  border: "solid 1px #e1e4e8",
                                },
                              }),
                            ]),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.chart.type &&
      _vm.chart.render === "antv" &&
      _vm.chart.type.includes("table")
        ? _c(
            "el-col",
            [
              _c(
                "el-col",
                [
                  _c("el-button", {
                    staticStyle: { width: "24px", "margin-left": "4px" },
                    attrs: {
                      title: _vm.$t("chart.edit"),
                      icon: "el-icon-edit",
                      type: "text",
                      size: "small",
                    },
                    on: { click: _vm.editTableThreshold },
                  }),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        padding: "0 18px",
                        "max-height": "500px",
                        "overflow-y": "auto",
                      },
                    },
                    _vm._l(
                      _vm.thresholdForm.tableThreshold,
                      function (fieldItem, fieldIndex) {
                        return _c(
                          "el-row",
                          { key: fieldIndex },
                          [
                            _c("el-row", { staticClass: "field-style" }, [
                              _c(
                                "span",
                                [
                                  fieldItem.field.deType === 0
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-text",
                                        attrs: { "icon-class": "field_text" },
                                      })
                                    : _vm._e(),
                                  fieldItem.field.deType === 1
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-time",
                                        attrs: { "icon-class": "field_time" },
                                      })
                                    : _vm._e(),
                                  fieldItem.field.deType === 2 ||
                                  fieldItem.field.deType === 3
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-value",
                                        attrs: { "icon-class": "field_value" },
                                      })
                                    : _vm._e(),
                                  fieldItem.field.deType === 5
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-location",
                                        attrs: {
                                          "icon-class": "field_location",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "field-text",
                                  attrs: { title: fieldItem.field.name },
                                },
                                [_vm._v(_vm._s(fieldItem.field.name))]
                              ),
                            ]),
                            _vm._l(
                              fieldItem.conditions,
                              function (item, index) {
                                return _c(
                                  "el-row",
                                  { key: index, staticClass: "line-style" },
                                  [
                                    _c("el-col", { attrs: { span: 6 } }, [
                                      item.term === "eq"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$t("chart.filter_eq"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_eq")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "not_eq"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "chart.filter_not_eq"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_not_eq")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "lt"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$t("chart.filter_lt"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_lt")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "gt"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$t("chart.filter_gt"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_gt")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "le"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$t("chart.filter_le"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_le")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "ge"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$t("chart.filter_ge"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_ge")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "between"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "chart.filter_between"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_between")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "like"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$t("chart.filter_like"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_like")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "not like"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "chart.filter_not_like"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "chart.filter_not_like"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "null"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$t("chart.filter_null"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_null")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "not_null"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "chart.filter_not_null"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "chart.filter_not_null"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "empty"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title:
                                                  _vm.$t("chart.filter_empty"),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("chart.filter_empty")
                                                )
                                              ),
                                            ]
                                          )
                                        : item.term === "not_empty"
                                        ? _c(
                                            "span",
                                            {
                                              attrs: {
                                                title: _vm.$t(
                                                  "chart.filter_not_empty"
                                                ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "chart.filter_not_empty"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _c("el-col", { attrs: { span: 10 } }, [
                                      !item.term.includes("null") &&
                                      !item.term.includes("empty") &&
                                      item.term !== "between"
                                        ? _c(
                                            "span",
                                            { attrs: { title: item.value } },
                                            [_vm._v(_vm._s(item.value))]
                                          )
                                        : !item.term.includes("null") &&
                                          !item.term.includes("empty") &&
                                          item.term === "between"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(item.min) +
                                                " ≤" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "chart.drag_block_label_value"
                                                  )
                                                ) +
                                                "≤ " +
                                                _vm._s(item.max) +
                                                "\n              "
                                            ),
                                          ])
                                        : _c("span", [_vm._v(" ")]),
                                    ]),
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _c("span", {
                                        style: {
                                          width: "14px",
                                          height: "14px",
                                          backgroundColor: item.color,
                                          border: "solid 1px #e1e4e8",
                                        },
                                        attrs: {
                                          title: _vm.$t("chart.textColor"),
                                        },
                                      }),
                                    ]),
                                    _c("el-col", { attrs: { span: 4 } }, [
                                      _c("span", {
                                        style: {
                                          width: "14px",
                                          height: "14px",
                                          backgroundColor: item.backgroundColor,
                                          border: "solid 1px #e1e4e8",
                                        },
                                        attrs: {
                                          title: _vm.$t(
                                            "chart.backgroundColor"
                                          ),
                                        },
                                      }),
                                    ]),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.editTextLabelThresholdDialog
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.threshold"),
                visible: _vm.editTextLabelThresholdDialog,
                "show-close": false,
                width: "800px",
                "append-to-body": "",
              },
            },
            [
              _c("text-label-threshold-edit", {
                attrs: { threshold: _vm.thresholdForm.textLabelThreshold },
                on: { onTextLabelThresholdChange: _vm.thresholdTextChange },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeTextLabelThreshold },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.changeTextLabelThreshold },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.editLabelThresholdDialog
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.threshold"),
                visible: _vm.editLabelThresholdDialog,
                "show-close": false,
                width: "800px",
                "append-to-body": "",
              },
            },
            [
              _c("text-threshold-edit", {
                attrs: { threshold: _vm.thresholdForm.labelThreshold },
                on: { onLabelThresholdChange: _vm.thresholdChange },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeLabelThreshold },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.changeLabelThreshold },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.editTableThresholdDialog
        ? _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              staticClass: "dialog-css",
              attrs: {
                title: _vm.$t("chart.threshold"),
                visible: _vm.editTableThresholdDialog,
                "show-close": false,
                width: "800px",
                "append-to-body": "",
              },
            },
            [
              _c("table-threshold-edit", {
                attrs: {
                  threshold: _vm.thresholdForm.tableThreshold,
                  chart: _vm.chart,
                },
                on: { onTableThresholdChange: _vm.tableThresholdChange },
              }),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini" },
                      on: { click: _vm.closeTableThreshold },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.changeTableThreshold },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.confirm")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }